import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ListView extends Icon {
  static defaultProps = {
    color: '#FFFFFF',
    size: 16,
    stroke: '#FFFFFF',
    viewPortSize: 16
  };

  static propTypes = {
    color: PropTypes.string,
    stroke: PropTypes.string,
    size: PropTypes.number,
    viewPortSize: PropTypes.number
  };

  render() {
    let { color, stroke, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color} stroke={stroke}>
          <g>
            <line
              fill="none"
              strokeWidth="2"
              strokeLinejoin="bevel"
              strokeMiterlimit="10"
              x1="16.7"
              y1="5.3"
              x2="5.9"
              y2="5.3"
            />
            <line
              fill="none"
              strokeWidth="2"
              strokeLinejoin="bevel"
              strokeMiterlimit="10"
              x1="16.7"
              y1="10"
              x2="5.9"
              y2="10"
            />
            <line
              fill="none"
              strokeWidth="2"
              strokeLinejoin="bevel"
              strokeMiterlimit="10"
              x1="16.7"
              y1="14.7"
              x2="5.9"
              y2="14.7"
            />
          </g>
          <g>
            <line
              fill="none"
              strokeWidth="2"
              strokeLinejoin="bevel"
              strokeMiterlimit="10"
              x1="4.7"
              y1="5.3"
              x2="3.3"
              y2="5.3"
            />
            <line
              fill="none"
              strokeWidth="2"
              strokeLinejoin="bevel"
              strokeMiterlimit="10"
              x1="4.7"
              y1="10"
              x2="3.3"
              y2="10"
            />
            <line
              fill="none"
              strokeWidth="2"
              strokeLinejoin="bevel"
              strokeMiterlimit="10"
              x1="4.7"
              y1="14.7"
              x2="3.3"
              y2="14.7"
            />
          </g>
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ListView.js